export * from './roleid2rolename.directive';



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/directives/roleid2rolename/index.ts